import { render, staticRenderFns } from "./ClientCheckTab.vue?vue&type=template&id=5f5fa38c&scoped=true"
import script from "./ClientCheckTab.vue?vue&type=script&lang=js"
export * from "./ClientCheckTab.vue?vue&type=script&lang=js"
import style0 from "./ClientCheckTab.vue?vue&type=style&index=0&id=5f5fa38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fa38c",
  null
  
)

export default component.exports